import { useQuery } from 'react-query';

import processResponseError from '@System/api/processResponseError';

import api from '../services/api';

const useListOrderQuery = params => {
    return useQuery(['ListOrderQuery', params], () => api.getOrders(params), {
        retry: false,
        onError: err => {
            processResponseError(err);
        },
    });
};

export default useListOrderQuery;
